import { BreadcrumbInlineRename } from "./BreadcrumbInlineRename";

import { useRenameAskPunttProject } from "../../../utils/queries/askPunttProjects";

/** Mirrors the backend `name` cap; the schema only enforces a non-empty name. */
const MAX_ASK_PUNTT_PROJECT_NAME_LENGTH = 200;

interface ProjectBreadcrumbTitleProps {
  projectId: string;
  name: string;
  /** Only the project owner may rename. Members get a read-only title. */
  canEdit: boolean;
}

/**
 * The project name in the project workspace header. For the owner it doubles as
 * a clean inline rename affordance via {@link BreadcrumbInlineRename}: the
 * resting title is plain text (no box) with a hover-revealed overlay pencil, and
 * edits persist via {@link useRenameAskPunttProject} with an optimistic cache
 * update. Keeps the `campaign-title` testid so the project page object + tests
 * resolve in both owner and member states.
 */
export function ProjectBreadcrumbTitle({
  projectId,
  name,
  canEdit,
}: ProjectBreadcrumbTitleProps) {
  const renameMutation = useRenameAskPunttProject(projectId);

  return (
    <BreadcrumbInlineRename
      title={name}
      canEdit={canEdit}
      isPending={renameMutation.isPending}
      onRename={(next) => renameMutation.mutate(next)}
      maxLength={MAX_ASK_PUNTT_PROJECT_NAME_LENGTH}
      triggerAriaLabel={`Rename project: ${name}`}
      pencilAriaLabel="Rename project"
      inputAriaLabel="Project name"
      readOnlyTestId="campaign-title"
      triggerTestId="project-breadcrumb-rename"
      pencilTestId="project-breadcrumb-rename-button"
      inputTestId="project-rename-input"
    />
  );
}
